import React from "react";
import PropTypes from "prop-types";
import { load } from "actions/basicScreeningResultsActions";
import ScreeningGroup from "./screeningGroup";
import { Loader } from "cxa-components";
import { FormattedCustomDate } from "components/common/FormattedComponents";

// Redux
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

class BasicScreeningResults extends React.Component {
  constructor(props) {
    super(props);

    this.handleLoad = this.handleLoad.bind(this);
    this.goToLaunchPad = this.goToLaunchPad.bind(this);
  }

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.load();
  }

  goToLaunchPad() {
    this.props.push("/wellness/launchpad");
  }

  render() {
    const { error, response, fetching } = this.props;

    if (fetching) {
      return <Loader />;
    }

    if (
      error ||
      !response ||
      !response.isSuccess ||
      (response.assessmentStatus && response.assessmentStatus.basicScreeningCompleted === false)
    ) {
      return null;
    }

    let screeningResults = [];

    if (response && response.categories && response.categories.length > 0) {
      screeningResults = response.categories.map((group, index) => (
        <ScreeningGroup key={index} data={group} basic={true} />
      ));
    }

    if (screeningResults.length == 0) {
      return null;
    }

    return (
      <div>
        <p>
          <FormattedMessage
            {...messages.lastUpdateTextDescription}
            values={{
              when: <FormattedCustomDate value={response.assessmentStatus.lastModifyOn} />,
              who: response.assessmentStatus.lastModifyBy,
            }}
          />
        </p>
        {screeningResults}
      </div>
    );
  }
}

BasicScreeningResults.propTypes = {
  error: PropTypes.object,
  response: PropTypes.object,
  load: PropTypes.func,
  fetching: PropTypes.bool,
  push: PropTypes.func,
};

const mapStateToProps = store => ({
  error: store.basicScreeningResults.error,
  response: store.basicScreeningResults.response,
  fetching: store.basicScreeningResults.fetching,
});

const mapDispatchToProps = {
  load,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BasicScreeningResults)
);



// WEBPACK FOOTER //
// ./components/employee/wellness/basicScreeningResults.jsx